import React from 'react'
import { useTranslations } from '~/components/Locale'
import type { HTMLElementProps } from '~/types'

type Props = HTMLElementProps<'button'>

export const MenuButton: React.FC<Props> = props => {
	const tMenu = useTranslations('react.actions.menu')
	return (
		<button className="button btn--square z-10 flex flex-nowrap items-stretch hover:opacity-80" {...props}>
			<span className="hidden md:inline">{tMenu}</span>
			<span className="site-header__navigation inline-block w-[80%] flex-shrink-0">
				<span className="burger-icon burger-icon--top" />
				<span className="burger-icon burger-icon--mid" />
				<span className="burger-icon burger-icon--bottom" />
			</span>
		</button>
	)
}
